<script setup lang="ts">
import "~/assets/css/main.css";

const gtm = useGtm();
const { gtag } = useGtag();
const { appEnv } = useRuntimeConfig().public;

useHead({
  meta: [
    {
      name: "viewport",
      content: computed(() => {
        const userAgent = window?.navigator.userAgent;

        return userAgent &&
          (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i))
          ? "width=device-width, initial-scale=1, maximum-scale=1"
          : "width=device-width, initial-scale=1";
      }),
    },
  ],
});

const setConsent = () => {
  const cookieConsentMarketing = window?.CookieInformation?.getConsentGivenFor(
    "cookie_cat_marketing"
  );
  const cookieConsentStatistic = window?.CookieInformation?.getConsentGivenFor(
    "cookie_cat_statistic"
  );

  gtm?.enable(cookieConsentStatistic);

  gtag("consent", "update", {
    ad_user_data: cookieConsentMarketing ? "granted" : "denied",
    ad_personalization: cookieConsentMarketing ? "granted" : "denied",
    ad_storage: cookieConsentMarketing ? "granted" : "denied",
    analytics_storage: cookieConsentStatistic ? "granted" : "denied",
  });

  // @ts-ignore
  window.uetq.push("consent", "update", {
    ad_storage: cookieConsentMarketing ? "granted" : "denied",
  });
};

onBeforeMount(() => {
  if (appEnv != "development") {
    window.addEventListener("CookieInformationConsentGiven", setConsent);
    setConsent();
  }
});

onMounted(() => {
  if (appEnv != "development") {
    window?.CookieInformation?.loadConsent();
  }
});
</script>

<template>
  <div id="top">
    <NuxtLoadingIndicator color="#076b9c" />
    <UApp>
      <NuxtLayout>
        <NuxtPage />
      </NuxtLayout>
    </UApp>
  </div>
</template>

<style lang="scss" scoped>
@include fade-transition;
</style>
